import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import Modal from '../../../../components/Modals/Modal';
import ApiDataViewer from './ApiDataViewer';
import { useApiDatas } from '../../../../services/apiDatas.service';
import Pagination from '../../../../components/Table/Pagination';
import { LoaderComponent } from '../../../../components/Table/styles';

export interface ApiDataModalHandle {
  openModal: (integrationId: string, integrationName: string) => void;
}

const ApiDataModal = forwardRef<ApiDataModalHandle, {}>((props, ref) => {
  const modalRef = useRef<any>(null);
  const [integrationId, setIntegrationId] = useState<string | null>(null);
  const [integrationName, setIntegrationName] = useState<string>('');
  const [page, setPage] = useState(1);

  const { data: apiData, isLoading } = useApiDatas(integrationId, page);

  useImperativeHandle(ref, () => ({
    openModal(id: string, name: string) {
      setIntegrationId(id);
      setIntegrationName(name);
      setPage(1);
      modalRef.current?.openModal();
    },
  }));

  const records = apiData?.data?.map((d: any) => d.data) || [];

  return (
    <Modal title={`Dados Importados: ${integrationName}`} ref={modalRef} isLarge>
      <div style={{ padding: 20, width: '100%', height: '80vh', display: 'flex', flexDirection: 'column' }}>
        {isLoading ? (
          <LoaderComponent />
        ) : (
          <div style={{ flex: 1, overflow: 'hidden' }}>
            <ApiDataViewer data={records} />
          </div>
        )}
        
        {apiData && (
          <Pagination
            totalPages={apiData.totalPages}
            page={page}
            perPage={apiData.limit}
            pageChangeHandler={setPage}
          />
        )}
      </div>
    </Modal>
  );
});

export default ApiDataModal;
